import { Injectable } from "@angular/core";
import {NgxSpinnerService} from "ngx-spinner";

@Injectable({
    providedIn: 'root'
})
export class SpinnerService{
    constructor(private _spinner: NgxSpinnerService){}

    showSpinner(){
        this._spinner.show(undefined, {
          type: 'ball-scale-multiple'
        });
    }

    hiddenSpinner(){
        this._spinner.hide();
    }
}
